import React from 'react';

import TerminalsTrxTable from "../TerminalsTrxTable";
import {Box} from "@material-ui/core";
import withState from "../../../../../../utils/withState";
import {apiTerminalsList} from "../../../../../../api/merchant/terminals";
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading';
import Tooltip from '../../../../../dumb/Tooltip/B';


export default withState((setState, self, onMount) => {
  const update = () => {
    setState({loading: true});

    return apiTerminalsList({offset: 0, limit: 100}).then((result) => {
      const list = (result || {}).list;

      const terminalsList = list.map((el) => {
        const name = el.device_name || el.name;

        return {
          id: el.id,
          headerNameDisplay: (
            name.length > 25
              ? `${name.substr(0, 25)}...`
              : name
          ),
          name: (
            name.length > 48
              ? `${name.substr(0, 43)}...`
              : name
          ),
        }
      });

      setState({terminalsList, loading: false});
    });
  }

  onMount(() => {
    update();
  })

  return (state) => {
    return (
      <WrapperWithLoading
        loading={state.loading}
      >
        <Box width="100%" height="calc(100vh - 200px)" minHeight="500px">
          <TerminalsTrxTable terminalsList={state.terminalsList} />
        </Box>
      </WrapperWithLoading>
    )
  }
});
